
const PERMISSIONS = Object.freeze({
  DASHBOARD: 'Dashboard',
  DASHBOARD_ADD: 'Dashboard-Add',
  DASHBOARD_DELETE: 'Dashboard-Delete',
  DASHBOARD_UPDATE: 'Dashboard-Update',
  DASHBOARD_VIEW: 'Dashboard-View',
  LEADS: 'Leads',
  LEADS_ADD: 'Leads-Add',
  LEADS_VIEW: 'Leads-View',
  LEADS_UPDATE: 'Leads-Update',
  LEADS_DELETE: 'Leads-Delete',
  LEADS_CREATEVIEWLIST: 'Leads-CreateViewList',
  LEADS_EDITVIEWLIST: 'Leads-EditViewList',
  LEADS_MASSDELETE: 'Leads-MassDelete',
  LEADS_MASSUPDATE: 'Leads-MassUpdate',
  ACCOUNTS: 'Accounts',
  ACCOUNTS_VIEW: 'Accounts-View',
  ACCOUNTS_UPDATE: 'Accounts-Update',
  ACCOUNTS_DELETE: 'Accounts-Delete',
  ACCOUNTS_CREATEVIEWLIST: 'Accounts-CreateViewList',
  ACCOUNTS_EDITVIEWLIST: 'Accounts-EditViewList',
  ACCOUNTS_MASSDELETE: 'Accounts-MassDelete',
  ACCOUNTS_MASSUPDATE: 'Accounts-MassUpdate',
  OPPORTUNITIES: 'Opportunities',
  OPPORTUNITIES_VIEW: 'Opportunities-View',
  OPPORTUNITIES_UPDATE: 'Opportunities-Update',
  OPPORTUNITIES_DELETE: 'Opportunities-Delete',
  OPPORTUNITIES_CREATEVIEWLIST: 'Opportunities-CreateViewList',
  OPPORTUNITIES_EDITVIEWLIST: 'Opportunities-EditViewList',
  OPPORTUNITIES_MASSDELETE: 'Opportunities-MassDelete',
  OPPORTUNITIES_MASSUPDATE: 'Opportunities-MassUpdate',
  REPORTS: 'Reports',
  REPORTS_ADD: 'Reports-Add',
  REPORTS_DELETE: 'Reports-Delete',
  REPORTS_UPDATE: 'Reports-Update',
  REPORTS_VIEW: 'Reports-View',
  SETUP: 'Setup',
  SETUP_COMPANYPROFILE: 'Setup-CompanyProfile',
  SETUP_COMPANYPROFILE_COMPANYINFORMATION: 'Setup-CompanyProfile-CompanyInformation',
  SETUP_COMPANYPROFILE_COMPANYINFORMATION_UPDATE: 'Setup-CompanyProfile-CompanyInformation-Update',
  SETUP_COMPANYPROFILE_COMPANYINFORMATION_UPDATELOGO: 'Setup-CompanyProfile-CompanyInformation-UpdateLogo',
  SETUP_COMPANYPROFILE_USERS: 'Setup-CompanyProfile-Users',
  SETUP_COMPANYPROFILE_USERS_ADD: 'Setup-CompanyProfile-Users-Add',
  SETUP_COMPANYPROFILE_USERS_DELETE: 'Setup-CompanyProfile-Users-Delete',
  SETUP_COMPANYPROFILE_USERS_FORCE_PASSWORD_RESET: 'Setup-CompanyProfile-Users-ForcePasswordReset',
  SETUP_COMPANYPROFILE_USERS_UPDATE: 'Setup-CompanyProfile-Users-Update',
  SETUP_COMPANYPROFILE_USERS_LOGINASUSER: 'Setup-CompanyProfile-Users-LoginAsUser',
  SETUP_COMPANYPROFILE_ORGANISATIONALCHART: 'Setup-CompanyProfile-OrganisationalChart',
  SETUP_COMPANYPROFILE_ORGANISATIONALCHART_ADD: 'Setup-CompanyProfile-OrganisationalChart-Add',
  SETUP_COMPANYPROFILE_ORGANISATIONALCHART_DELETE: 'Setup-CompanyProfile-OrganisationalChart-Delete',
  SETUP_COMPANYPROFILE_ORGANISATIONALCHART_UPDATE: 'Setup-CompanyProfile-OrganisationalChart-Update',
  SETUP_COMPANYPROFILE_PERMISSIONPROFILE: 'Setup-CompanyProfile-PermissionProfile',
  SETUP_COMPANYPROFILE_PERMISSIONPROFILE_UPDATE: 'Setup-CompanyProfile-PermissionProfile-Update',
  SETUP_LEADS: 'Setup-Leads',
  SETUP_LEADS_FIELDS: 'Setup-Leads-Fields',
  SETUP_LEADS_FIELDS_ADD: 'Setup-Leads-Fields-Add',
  SETUP_LEADS_FIELDS_DELETE: 'Setup-Leads-Fields-Delete',
  SETUP_LEADS_FIELDS_UPDATE: 'Setup-Leads-Fields-Update',
  SETUP_LEADS_PAGELAYOUT: 'Setup-Leads-PageLayout',
  SETUP_LEADS_PAGELAYOUT_ADD: 'Setup-Leads-PageLayout-Add',
  SETUP_LEADS_PAGELAYOUT_DELETE: 'Setup-Leads-PageLayout-Delete',
  SETUP_LEADS_PAGELAYOUT_UPDATE: 'Setup-Leads-PageLayout-Update',
  SETUP_LEADS_PAGELAYOUT_ASSIGN: 'Setup-Leads-PageLayout-Assign',
  SETUP_ACCOUNTS: 'Setup-Accounts',
  SETUP_ACCOUNTS_FIELDS: 'Setup-Accounts-Fields',
  SETUP_ACCOUNTS_FIELDS_ADD: 'Setup-Accounts-Fields-Add',
  SETUP_ACCOUNTS_FIELDS_DELETE: 'Setup-Accounts-Fields-Delete',
  SETUP_ACCOUNTS_FIELDS_UPDATE: 'Setup-Accounts-Fields-Update',
  SETUP_ACCOUNTS_PAGELAYOUT: 'Setup-Accounts-PageLayout',
  SETUP_ACCOUNTS_PAGELAYOUT_ADD: 'Setup-Accounts-PageLayout-Add',
  SETUP_ACCOUNTS_PAGELAYOUT_DELETE: 'Setup-Accounts-PageLayout-Delete',
  SETUP_ACCOUNTS_PAGELAYOUT_UPDATE: 'Setup-Accounts-PageLayout-Update',
  SETUP_ACCOUNTS_PAGELAYOUT_ASSIGN: 'Setup-Accounts-PageLayout-Assign',
  SETUP_OPPORTUNITIES: 'Setup-Opportunities',
  SETUP_OPPORTUNITIES_FIELDS: 'Setup-Opportunities-Fields',
  SETUP_OPPORTUNITIES_FIELDS_ADD: 'Setup-Opportunities-Fields-Add',
  SETUP_OPPORTUNITIES_FIELDS_DELETE: 'Setup-Opportunities-Fields-Delete',
  SETUP_OPPORTUNITIES_FIELDS_UPDATE: 'Setup-Opportunities-Fields-Update',
  SETUP_OPPORTUNITIES_PAGELAYOUT: 'Setup-Opportunities-PageLayout',
  SETUP_OPPORTUNITIES_PAGELAYOUT_ADD: 'Setup-Opportunities-PageLayout-Add',
  SETUP_OPPORTUNITIES_PAGELAYOUT_DELETE: 'Setup-Opportunities-PageLayout-Delete',
  SETUP_OPPORTUNITIES_PAGELAYOUT_UPDATE: 'Setup-Opportunities-PageLayout-Update',
  SETUP_OPPORTUNITIES_PAGELAYOUT_ASSIGN: 'Setup-Opportunities-PageLayout-Assign',
  SETUP_EMAILCOMMUNICATIONS: 'Setup-EmailCommunications',
  SETUP_EMAILCOMMUNICATIONS_EMAILTEMPLATES: 'Setup-EmailCommunications-EmailTemplates',
  SETUP_EMAILCOMMUNICATIONS_EMAILTEMPLATES_VIEW: 'Setup-EmailCommunications-EmailTemplates-View',
  SETUP_EMAILCOMMUNICATIONS_EMAILTEMPLATES_ADD: 'Setup-EmailCommunications-EmailTemplates-Add',
  SETUP_EMAILCOMMUNICATIONS_EMAILTEMPLATES_DELETE: 'Setup-EmailCommunications-EmailTemplates-Delete',
  SETUP_EMAILCOMMUNICATIONS_EMAILTEMPLATES_UPDATE: 'Setup-EmailCommunications-EmailTemplates-Update',
  SETUP_EMAILCOMMUNICATIONS_EMAILTEMPLATES_ASSIGN: 'Setup-EmailCommunications-EmailTemplates-Assign',
  SETUP_EMAILCOMMUNICATIONS_EMAILTEMPLATES_EDITMYFOLDERS: 'Setup-EmailCommunications-EmailTemplates-EditMyFolders',
  SETUP_EMAILCOMMUNICATIONS_EMAILTEMPLATES_SHOWTEAMSTRUCTURE: 'Setup-EmailCommunications-EmailTemplates-ShowTeamStructure',
  TASKOPEN: 'Tasks',
  TASKOPEN_VIEW: 'Tasks-View',
  TASKOPEN_ADD: 'Tasks-Add',
  TASKOPEN_UPDATE: 'Tasks-Update',
  TASKOPEN_DELETE: 'Tasks-Delete',
  INVOICE: 'Invoices',
  INVOICE_VIEW: 'Invoices-View',
  INVOICE_ADD: 'Invoices-Add',
  INVOICE_UPDATE: 'Invoices-Update',
  INVOICE_DELETE: 'Invoices-Delete',
  ATTACHMENTS: 'Attachments',
  ATTACHMENTS_VIEW: 'Attachments-View',
  ATTACHMENTS_ADD: 'Attachments-Add',
  ATTACHMENTS_UPDATE: 'Attachments-Update',
  ATTACHMENTS_DELETE: 'Attachments-Delete',
  SETUP_SYSTEMS: 'Setup-Systems',
  SETUP_SYSTEMS_IPWHITELIST: 'Setup-Systems-IPWhiteList',
  SETUP_SYSTEMS_IPWHITELIST_VIEW: 'Setup-Systems-IPWhiteList-View',
  SETUP_SYSTEMS_IPWHITELIST_ADD: 'Setup-Systems-IPWhiteList-Add',
  SETUP_SYSTEMS_IPWHITELIST_DELETE: 'Setup-Systems-IPWhiteList-Delete',
  SETUP_SYSTEMS_IPWHITELIST_UPDATE: 'Setup-Systems-IPWhiteList-Update',
  SETUP_GENERALSETTINGS: 'Setup-GeneralSettings',
  SETUP_GENERALSETTINGS_SEARCHLAYOUT: 'Setup-GeneralSettings-SearchLayout',
  SETUP_GENERALSETTINGS_SEARCHLAYOUT_VIEW: 'Setup-GeneralSettings-SearchLayout-View',
  SETUP_GENERALSETTINGS_SEARCHLAYOUT_UPDATE: 'Setup-GeneralSettings-SearchLayout-Update',
  SETUP_GENERALSETTINGS_OTHERSETTINGS: 'Setup-GeneralSettings-OtherSettings',
  SETUP_GENERALSETTINGS_OTHERSETTINGS_VIEW: 'Setup-GeneralSettings-OtherSettings-View',
  SETUP_GENERALSETTINGS_OTHERSETTINGS_UPDATE: 'Setup-GeneralSettings-OtherSettings-Update',
  SETUP_OBJECTSIMPORT: 'Setup-ObjectsImport',
  SETUP_OBJECTSEXPORT: 'Setup-ObjectsExport',
  SETUP_WORKFLOW: 'Setup-Workflow',
  SETUP_APITOKEN: 'Setup-ApiToken',
  SETUP_APITOKEN_VIEW:'Setup-ApiToken-View',
  SETUP_APITOKEN_UPDATE: 'Setup-ApiToken-Update',
  SETUP_APITOKEN_DELETE: 'Setup-ApiToken-Delete',
  SETUP_APITOKEN_ADD: 'Setup-ApiToken-Add'
});
export default PERMISSIONS;



// WEBPACK FOOTER //
// ./src/config/app-permission.config.js